import React from 'react';
import { ActionButton } from '@klp/design/Action';
import { Block } from '@klp/design/Block';
import { getSuperofficeProsjektUrlByProsjektId } from '@klp/prosjekt/utils';
import { useProsjektSammendragContext } from './context/ProsjektSammendragProvider';

export const ProsjektSammendragProjectActions: React.FC = () => {
    const { prosjektId } = useProsjektSammendragContext();

    const handleOpenInSuperoffice =
        (id?: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
            if (!id) return;
            event.stopPropagation();
            window.open(getSuperofficeProsjektUrlByProsjektId(id), '_blank');
        };
    return (
        <Block>
            <ActionButton
                actionType="external"
                variant="contained"
                color="secondary"
                onClick={handleOpenInSuperoffice(prosjektId)}
                translation="prosjekt.table.visProsjektISuperoffice"
            />
        </Block>
    );
};
